'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = UIPopoverBody;

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _sizes = require('HubStyleTokens/sizes');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _PopoverContext = require('../context/PopoverContext');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var Body = _styledComponents2.default.div.withConfig({
  displayName: 'UIPopoverBody__Body'
})(['background:inherit;padding:', ';', ';'], function (_ref) {
  var flush = _ref.flush,
      popoverUse = _ref.popoverUse;

  if (flush) return '0';
  if (popoverUse === 'longform') return '0 ' + _sizes.TOOLTIP_LONGFORM_PADDING + ' 1px';
  if (popoverUse === 'shepherd') return _sizes.SHEPHERD_PADDING_Y + ' ' + _sizes.POPOVER_PADDING_X;
  if (popoverUse.includes('tooltip')) return _sizes.TOOLTIP_PADDING_Y + ' ' + _sizes.TOOLTIP_PADDING_X;
  return _sizes.POPOVER_PADDING_Y + ' ' + _sizes.POPOVER_PADDING_X + ' 0';
}, function (_ref2) {
  var popoverUse = _ref2.popoverUse;

  if (popoverUse === 'shepherd') return (0, _styledComponents.css)(['border-bottom-left-radius:inherit;border-bottom-right-radius:inherit;']);
  if (popoverUse.includes('tooltip')) return (0, _styledComponents.css)(['border-radius:inherit;line-height:1.5;']);
  return null;
});

function UIPopoverBody(_ref3) {
  var className = _ref3.className,
      rest = _objectWithoutProperties(_ref3, ['className']);

  return _react2.default.createElement(Body, _extends({}, rest, {
    className: (0, _classnames2.default)('uiPopoverBody private-popover__body', className),
    popoverUse: (0, _react.useContext)(_PopoverContext.PopoverContext).use
  }));
}

UIPopoverBody.propTypes = {
  children: _propTypes2.default.node,
  flush: _propTypes2.default.bool
};

UIPopoverBody.displayName = 'UIPopoverBody';
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3620/js/tooltip/UIPopoverBody.js
// module id = 470
// module chunks = 177